import React from "react";
import { cn } from "@/lib/format";

export type BadgeVariant =
  | "default"
  | "amber"
  | "navy"
  | "teal"
  | "moss"
  | "dark";

const VARIANT_MAP: Record<BadgeVariant, string> = {
  default: "bg-paper text-muted",
  amber: "bg-secondary/20 text-secondary-dark",
  navy: "bg-primary/10 text-primary-dark",
  teal: "bg-info/20 text-info",
  moss: "bg-success/20/80 text-success",
  dark: "bg-primary text-secondary/60",
};

type Props = {
  variant?: BadgeVariant;
  className?: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
};

export function Badge({
  variant = "default",
  className,
  children,
  icon,
}: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-3 py-1.5 font-mono text-[10.5px] font-medium tracking-widest rounded-full",
        VARIANT_MAP[variant],
        className,
      )}
    >
      {icon && <span className="shrink-0">{icon}</span>}
      {children}
    </span>
  );
}
